import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { getAccounts } from "app/services/dashboard/accountService";

import { getDoctors } from "app/services/dashboard/doctorAnalyticService";
import { BASE_URL } from "static/constants";

export const doctorAnalyticApi = createApi({
  reducerPath: "doctorAnalyticApi",
  baseQuery: fetchBaseQuery({ baseUrl: BASE_URL }),
  endpoints: (builder) => ({
    getDoctorAnalytic: builder.query({
      queryFn: ({ startDate, endDate, account, sort, name }) => {
        return {
          data: getDoctors({
            startDate,
            endDate,
            account,
            sort,
            name,
            isExport: false,
          }),
        };
      },
    }),
    fetchAccountList: builder.query({
      queryFn: () => {
        return { data: getAccounts() };
      },
    }),
    downloadReport: builder.mutation({
      queryFn: ({ startDate, endDate, account, sort, name, isExport }) => {
        return {
          data: getDoctors({
            startDate,
            endDate,
            account,
            sort,
            name,
            isExport,
          }),
        };
      },
    }),
  }),
});

export const {
  useGetDoctorAnalyticQuery,
  useFetchAccountListQuery,
  useDownloadReportMutation,
} = doctorAnalyticApi;
